export default __webpack_public_path__ + "static/media/nft2.2483ff62.png";